import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { types } from '../../../store/user/types';
import { types as formTypes } from '../../../store/forms/types';
import { PageTitle, PageLabeledButton } from 'components';
import { readUrlParams, resolveMessageCode } from 'utils';

const AuthErrorPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const message = useSelector(state => state.forms.message);

  useEffect(() => {
    dispatch({ type: types.RESET_USER });
    dispatch({ type: formTypes.RESET_FORM });
    
    const urlParams = readUrlParams();
    if (urlParams.reason) {
      const errorMessage = resolveMessageCode(urlParams.reason);
      dispatch({ type: formTypes.SET_FORM_ERROR, payload: errorMessage });
    }
    
    dispatch({ type: formTypes.SET_FORM_INITIATED });
  }, [dispatch]);

  const handleLoginRedirect = () => {
    navigate('/login');
  };

  return (
    <div className="autherror-page">
      <PageTitle 
        message="Σφάλμα Πιστοποίησης" 
        pageName="autherror" 
      />
      
      <PageLabeledButton 
        labelMessage={message || "Προέκυψε ένα σφάλμα κατά την πιστοποίηση."}
        pageName="login-redirect"
        buttonTitle="Είσοδος"
        buttonAction={handleLoginRedirect}
      />
    </div>
  );
};

export default AuthErrorPage;